export default {
  wrapper: {
    margin: ['12px auto 0 auto', '40px auto 0 auto', '60px auto 0 auto'],
    color: '#333D47',
    fontFamily: 'regular',
    maxWidth: ['100%', '675px', '716px'],

    label: {
      fontSize: ['16px', '16px', '25px'],
      margin: ['12px 0 6px 0', '20px 0 0 0', '20px 0 5px 0'],
      lineHeight: ['21px', '21px', '33px'],
    },
    'input, select': {
      fontSize: ['16px', '16px', '16px'],
      background: '#F9F9F9',
      border: '1px solid #333D47',
      borderRadius: '0',

      '&::placeholder': {
        color: '#999',
      },
      '&:invalid': {
        color: '#999',
      },
    },
    'input[name="name"]': {
      fontFamily: 'spoqaRegular',
    },
  },
  guideText: {
    fontSize: ['14px', '16px', '25px'],
    fontFamily: 'spoqaBold',
  },
  formTextError: {
    fontSize: ['12px', '14px', '14px'],
    color: 'sideNavRed',
    // 2 / 1 / 3 / 2
    gridArea: ['1 / 1 / 2 / 2', '1 / 1 / 2 / 2', '1 / 1 / 2 / 2'],
    display: ['block', '', ''],
    fontFamily: 'spoqaRegular',
  },
  customCheckboxButton: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: ['6px', '3px', '10px'],
    width: ['322px', '322px', '322px'],
    backgroundColor: '#E9E9E9',
    fontSize: ['16px', '16px', '20px'],
    fontFamily: 'heading',
    textTransform: 'uppercase',
    borderRadius: '8px',
    justifyContent: 'space-evenly',

    label: {
      margin: '0 !important',
      marginBottom: '0px!important',
      fontSize: ['16px', '16px', '20px'],
    },

    input: {
      marginBottom: '0px !important',
      opacity: '0',
      width: '1px',
      height: '1px',
      position: 'absolute',
    },

    span: {
      padding: ['3px 0', '3px 0', '1px 0'],
      color: 'black',
      borderRadius: '8px',
      minWidth: ['162px', '162px', '162px'],
      textAlign: 'center',
      display: 'block',
    },

    'input:checked + span': {
      color: 'tmWhite',
      background: '#12295B',
    },
  },
  customLargeCheckboxButton: {
    width: ['322px', '370px', '430px'],
    span: {
      padding: ['3px 14px', '3px 14px', '1px 14px'],
      color: 'black',
      borderRadius: '8px',
      minWidth: ['160px', '161px', '212px'],
      textAlign: 'center',
      display: 'block',
    },
  },
  bottomContent: {
    display: 'grid',
    gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(2, 1fr)'],
    gridTemplateRows: ['repeat(2, 1fr)', '1fr', '1fr'],
    gap: '0px 0px',
    gridTemplateAreas: 'error text',
    margin: ['5px 0 0 0', '', '5px 0 0 0'],
  },
  helperText: {
    fontSize: ['11px', '14px', '14px'],
    color: '#999',
    gridArea: ['1 / 1 / 2 / 2', '1 / 2 / 2 / 3', '1 / 2 / 2 / 3'],
    textAlign: 'end',
    display: ['block', '', ''],
    fontFamily: 'spoqaRegular',
  },
}
